<template>
    <g-base-box :class="classes" padding="p-0">
        <div class="product-panel-item-image">
            <g-image-thumbnail
                :image-link="product.image"
                :image-description="product.name"
                image-units-string="%"
                :background-blur="false"
                background-color="#ffffff"
            />
        </div>
        <div class="content">
            <g-typography
                class="product-title"
                tag="h3"
                font-weight="semibold"
                :value="product.name"
                text-overflow="ellipsis"
            />
            <g-row type="flex" align="bottom" justify="space-between">
                <g-column v-if="showPrices" :span="inStock ? 24 : 8">
                    <g-typography class="product-desc" tag="h4" :value="productPrice" text-overflow="ellipsis" />
                </g-column>
                <g-column v-if="!inStock" :span="showPrices ? 16 : 24">
                    <g-typography
                        class="product-desc"
                        tag="h4"
                        font-color="error"
                        value="Out of Stock"
                        text-overflow="ellipsis"
                        text-align="right"
                    />
                </g-column>
            </g-row>
        </div>
    </g-base-box>
</template>

<script>
    import { get } from 'lodash';
    import ActivationBriefProductConfigMixin from '../../mixins/ActivationBriefProductConfigMixin';
    import { formatCurrency } from '../../../../../helpers/formatters';

    export default {
        name: 'ProductPanelItem',
        props: {
            product: {
                type: Object,
                required: true
            }
        },
        mixins: [ActivationBriefProductConfigMixin],
        computed: {
            inStock() {
                return this.product.is_in_stock;
            },
            productPrice() {
                return formatCurrency(this.product.price, get(this, 'brief.brand.currency', 'usd'));
            },
            classes() {
                return {
                    'product-panel-item': true,
                    'product-panel-item-faded': !this.inStock
                };
            }
        }
    };
</script>

<style lang="scss" scoped>
    .product-panel-item {
        border: 0.125rem solid lightgray;
        border-radius: 0.25rem;
    }
    .product-panel-item-faded {
        opacity: 0.6;
    }
    .content {
        height: 80px;
        padding: 6px;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        * {
            margin-bottom: 4px;
            color: #252a30;
        }
        .product-title {
            font-size: 1rem;
            line-height: 1.5rem;
        }
        .product-desc {
            font-size: 0.88rem;
            line-height: 1.3rem;
        }

        /* restore the proper font weight lost to .content styles */
        .g-font-semibold {
            font-weight: 600;
        }
        .g-font-normal {
            font-weight: 400;
        }
    }
    .product-panel-item-image {
        height: 200px;
        width: 100%;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
    }
</style>
